const ModuleIdentifierConst = {
  DATA_MANAGEMENT: 'dataManagement',
  INPUTSOURCE_MANAGEMENT: 'inputSourceManagement',
  OUTPUTSOURCE_MANAGEMENT: 'unifiedSourceManagement',
  MASTERSOURCE_MANAGEMENT: 'masterManagement',
};

export default ModuleIdentifierConst;
